import React from 'react';
import { Box, Container, Typography, useMediaQuery } from '@mui/material';
import '../Components/IconWalk.css';

const Solution = () => {
  const isMobile = useMediaQuery('(max-width: 767px)');

  const images = [
    {
      src: 'assets/logo-nobu.png',
      width: isMobile ? '60px' : '130px',
      height: isMobile ? '40px' : '40px',
    },
    {
      src: 'assets/logo-nobi-dana-kripto_w.png',
      width: isMobile ? '60px' : '130px',
      height: isMobile ? '40px' : '40px',
    },
    {
      src: 'assets/idrp-logo.webp',
      width: isMobile ? '60px' : '130px',
      height: isMobile ? '40px' : '40px',
    },
    {
      src: 'assets/logo-bni-new.png',
      width: isMobile ? '60px' : '130px',
      height: isMobile ? '30px' : '40px',
    },
    {
      src: 'assets/idrx-logo-horizontal.webp',
      width: isMobile ? '60px' : '80px',
      height: isMobile ? '30px' : '40px',
    },
    {
      src: 'https://cdn.builder.io/api/v1/image/assets/TEMP/206aa7078d542c41e024a7e762643f614bacbaff1f00fd5e072b7ad06fd0d904?placeholderIfAbsent=true&apiKey=e3ddd6dd58b748b09fc1391939743920',
      width: isMobile ? '60px' : '130px',
      height: isMobile ? '20px' : '40px',
    }
  ];

  return (
    <section
      style={{
        backgroundColor: '#E7E4E2',
        padding: isMobile ? '1rem 0' : '4rem 0',
        position: 'relative',
        marginTop: isMobile ? '-2rem' : '-6rem',
        fontFamily: 'Poppins',
      }}
    >
      <Container
        style={{
          width: '90%',
          maxWidth: isMobile ? '100%' : '1260px',
          backgroundColor: '#E7E4E2',
          padding: isMobile ? '1rem' : '1.5rem',
          paddingBottom: isMobile ? '1.5rem' : '3rem',
          boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15)',
          borderRadius: '1rem',
          marginTop: isMobile ? '-5rem' : '-8rem',
          position: 'relative',
          zIndex: '1',
          fontFamily: 'Poppins',
        }}
      >
        <Typography
          variant="h4"
          align="center"
          gutterBottom
          style={{
            WebkitBackgroundClip: 'text',
            backgroundClip: 'text',
            color: '#2D669B',
            marginTop: isMobile ? '0.5rem' : '1rem',
            marginBottom: isMobile ? '1rem' : '2rem',
            fontFamily: 'Poppins',
            fontWeight: 600,
            fontSize: isMobile ? '14px' : '30px',
          }}
        >
          Trusted by Our Partners
        </Typography>

        <Box className="scroll-container2" display="flex" justifyContent="center">
          <Box
            className={isMobile ? 'icon-walk' : ''}
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexWrap={isMobile ? 'nowrap' : 'wrap'}
            gap={isMobile ? '0.5rem' : '1rem'}
            maxWidth="100%"
          >
            {images.map((image, index) => (
              <Box
                key={index}
                display="flex"
                justifyContent="center"
                alignItems="center"
                style={{
                  padding: isMobile ? '0.25rem' : '1rem',
                  backgroundColor: '#E7E4E2',
                  textAlign: 'center',
                  border: '1px solid #C3BFBD',
                  borderRadius: '0.5rem',
                  minWidth: isMobile ? '78px' : '210px',
                  height: isMobile ? '38px' : '95px',
                }}
              >
                <img
                  src={image.src}
                  alt={`Image ${index + 1}`}
                  style={{
                    width: image.width,
                    height: image.height,
                    objectFit: 'contain',
                  }}
                />
              </Box>
            ))}
          </Box>
        </Box>
      </Container>
    </section>
  );
};

export default Solution;
